// Angular 2
import { Component, HostListener, Inject, OnInit } from '@angular/core';
// Decorators
import { Theme } from '../../decorators/theme.decorator';
import { DOCUMENT } from '@angular/common';

// Component configuration

@Component({
  selector: 'sc-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.css']
})
export class SubHeaderComponent implements OnInit {
  @Theme() public theme: string;

  public isHide = false;
  public currentScroll = 0;

  constructor(@Inject(DOCUMENT) private document: any) {}

  public ngOnInit(): void {}

  @HostListener('window:scroll', [])
  public onWindowScroll() {
    const numberVar = this.document.documentElement.scrollTop;
    if (numberVar > this.currentScroll) {
      this.isHide = true;
    }
    if (numberVar < this.currentScroll) {
      this.isHide = false;
    }
    this.currentScroll = numberVar;
  }
}
